import {
  STATUS_REVIEW,
  GENDER_TYPES,
  STATUS_TYPES,
  REVIEW_STATUS_TYPES,
  STATUS_STOCKS_IN,
  TYPE_NOTIFY,
  SOURCE_OPTIONS,
} from './constants';

import dayjs from 'dayjs';
/**
 * Map data options
 * @param {Array} data
 * @return {Array}
 */
export const mapDataOptions4Select = (data, valueName = 'value', labelName = 'label') => {
  return (data || []).map((_item) => {
    let item = { ..._item };
    let { id, name, label, value } = item;
    label = name || item[labelName];
    value = id || item[valueName];
    return { ..._item, label, value };
  });
};
export function mapDataOptions4SelectCustom(data, valueName = 'value', labelName = 'label') {
  return (data || []).map((_item) => {
    let item = { ..._item };
    let { id, name, label, value } = item;
    label = name || item[labelName];
    value = 1 * id || 1 * item[valueName];
    return { ..._item, label, value };
  });
}

export const readImageAsBase64 = (img, callback) => {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
};

export const getBase64 = (file) => {
  if (file instanceof Blob)
    return new Promise((resolve) => {
      let baseURL = '';
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        baseURL = reader.result;
        resolve(baseURL);
      };
      return baseURL;
    });
};

export const changeDate = (val) => {
  if (!val) return '';
  let str = val;
  str = str.trim();
  str = str.replace('thứ hai', 'T2');
  str = str.replace('thứ ba', 'T3');
  str = str.replace('thứ tư', 'T4');
  str = str.replace('thứ năm', 'T5');
  str = str.replace('thứ sáu', 'T6');
  str = str.replace('thứ bảy', 'T7');
  str = str.replace('chủ nhật', 'CN');

  str = str.replace('Mon', 'T2');
  str = str.replace('Tue', 'T3');
  str = str.replace('Wed', 'T4');
  str = str.replace('Thu', 'T5');
  str = str.replace('Fri', 'T6');
  str = str.replace('Sat', 'T7');
  str = str.replace('Sun', 'CN');
  str = str.trim();
  return str;
};

export const sourceCustomerOption = [
  {
    label: 'Tất cả',
    value: SOURCE_OPTIONS.ALL,
  },
  {
    label: 'Mới',
    value: SOURCE_OPTIONS.NEW,
  },
  {
    label: 'Cũ',
    value: SOURCE_OPTIONS.OLD,
  },
];

export const statusTypesOption = [
  {
    label: 'Tất cả',
    value: STATUS_TYPES.ALL,
  },
  {
    label: 'Kích hoạt',
    value: STATUS_TYPES.ACTIVE,
  },
  {
    label: 'Ẩn',
    value: STATUS_TYPES.HIDDEN,
  },
];

export const statusReviewOption = [
  {
    label: 'Tất cả',
    value: STATUS_REVIEW.ALL,
  },
  {
    label: 'Đã duyệt',
    value: STATUS_REVIEW.REVIEWED,
  },
  {
    label: 'Chưa duyệt',
    value: STATUS_REVIEW.REVIEWING,
  },
  {
    label: 'Không duyệt',
    value: STATUS_REVIEW.NOTREVIEW,
  },
];

export const genderTypesOptions = [
  {
    label: 'Tất cả',
    value: GENDER_TYPES.ALL,
  },
  {
    label: 'Nam',
    value: GENDER_TYPES.MALE,
  },
  {
    label: 'Nữ',
    value: GENDER_TYPES.FEMALE,
  },
];
export const deletedStatusOption = [
  {
    label: 'Tất cả',
    value: STATUS_TYPES.ALL,
  },
  {
    label: 'Có',
    value: STATUS_TYPES.ACTIVE,
  },
  {
    label: 'Không',
    value: STATUS_TYPES.HIDDEN,
  },
];

export const reviewStatusOption = [
  {
    label: 'Tất cả',
    value: REVIEW_STATUS_TYPES.ALL,
  },
  {
    label: 'Đã duyệt',
    value: REVIEW_STATUS_TYPES.REVIEWED,
  },
  {
    label: 'Đang duyệt',
    value: REVIEW_STATUS_TYPES.REVIEWING,
  },
  {
    label: 'Chưa duyệt',
    value: REVIEW_STATUS_TYPES.NOTYETREVIEW,
  },
  {
    label: 'Không duyệt',
    value: REVIEW_STATUS_TYPES.NOREVIEW,
  },
];
export const stockInStatusOption = [
  {
    value: STATUS_STOCKS_IN.ALL,
    label: 'Tất cả',
  },
  {
    value: STATUS_STOCKS_IN.STOCKED,
    label: 'Đã nhập kho',
  },
  {
    value: STATUS_STOCKS_IN.NOTYETSTOCKED,
    label: 'Chưa nhập kho',
  },
];

export const removeCharactersVietnamese = (str) => {
  // remove accents
  var from = 'àáãảạăằắẳẵặâầấẩẫậèéẻẽẹêềếểễệđùúủũụưừứửữựòóỏõọôồốổỗộơờớởỡợìíỉĩịäëïîöüûñçýỳỹỵỷ',
    to = 'aaaaaaaaaaaaaaaaaeeeeeeeeeeeduuuuuuuuuuuoooooooooooooooooiiiiiaeiiouuncyyyyy';

  for (var i = 0, l = from.length; i < l; i++) {
    str = str.replace(RegExp(from[i], 'gi'), to[i]);
  }

  str = str
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\-]/g, '')
    .replace(/-+/g, '');

  return str;
};

export const defaultPaging = {
  items: [],
  itemsPerPage: 0,
  page: 0,
  totalItems: 0,
  totalPages: 0,
};

export const defaultParams = {
  is_active: 1,
  page: 1,
  itemsPerPage: 25,
};

export const generateUUID = () => {
  let dt = new Date().getTime();
  let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    let r = (dt + Math.random() * 16) % 16 | 0;
    dt = Math.floor(dt / 16);
    return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
  return uuid;
};

export const isFunctionComponent = (component) => {
  return typeof component === 'function' && String(component).includes('return React.createElement');
};

export const typeNotifyOptions = [
  {
    value: TYPE_NOTIFY.MAIL,
    label: 'Danh sách mail',
    icon: 'fi-rr-envelope-open-text',
    //#url api
    apiUrl: 'global/notify',
    redirectUrl: (id, children_id) => {
      if (children_id) {
        return 'mail/detail/' + id + '?children_id=' + children_id;
      }
      return 'mail/detail/' + id;
    },
  },
  {
    value: TYPE_NOTIFY.ANNOUNCE,
    label: 'Danh sách thông báo',
    apiUrl: 'global/notify',
    icon: 'fi-rr-bell',
    redirectUrl: (id) => {
      return 'notification/detail/' + id;
    },
  },
];

export const getDateDDMMYYYYNow = () => {
  const today = new Date();
  const yyyy = today.getFullYear();
  let mm = today.getMonth() + 1; // Months start at 0!
  let dd = today.getDate();

  if (dd < 10) dd = '0' + dd;
  if (mm < 10) mm = '0' + mm;

  const formattedToday = dd + '' + mm + '' + yyyy;
  return formattedToday;
};

export function formatDate(date, template) {
  const isValidDate = dayjs(date).isValid();
  const defaultTemplate = 'DD/MM/YYYY';
  if (isValidDate) {
    return dayjs(date).format(template || defaultTemplate);
  }
  return null;
}
export const formatCurrency = (value = 0) =>
  new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(value ?? 0);
